import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

const IconShare = ({ className, titleAccess }: IconSpecificProps) => (
  <Icon className={className} titleAccess={titleAccess} viewBox="0 0 24 24" fill="none">
    <path
      d="M8.59 13.5099L15.42 17.4899M15.41 6.50988L8.59 10.4899M21 4.99988C21 6.65673 19.6569 7.99988 18 7.99988C16.3431 7.99988 15 6.65673 15 4.99988C15 3.34302 16.3431 1.99988 18 1.99988C19.6569 1.99988 21 3.34302 21 4.99988ZM9 11.9999C9 13.6567 7.65685 14.9999 6 14.9999C4.34315 14.9999 3 13.6567 3 11.9999C3 10.343 4.34315 8.99988 6 8.99988C7.65685 8.99988 9 10.343 9 11.9999ZM21 18.9999C21 20.6567 19.6569 21.9999 18 21.9999C16.3431 21.9999 15 20.6567 15 18.9999C15 17.343 16.3431 15.9999 18 15.9999C19.6569 15.9999 21 17.343 21 18.9999Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconShare;
